<ng-container *ngIf="type == 'icon'; then iconButton; else normalButton">
</ng-container>

<ng-template #iconButton>
  <button *ngIf="type == 'icon'; else normalButton" mat-icon-button [disabled]="disabled" (click)="functionInvoker()">
    <mat-icon [fontIcon]="icon"></mat-icon>
  </button>
</ng-template>

<ng-template #normalButton>
  <ng-container *ngIf="type === 'flat-button'; then primaryButton; else checkForOther">
  </ng-container>
  <ng-template #primaryButton>
    <button mat-flat-button [disabled]="disabled" class="primary-button" [ngClass]="{
      'medium': size === 'medium',
        'small': size === 'small'
    }">
      <mat-icon *ngIf="icon !== ''" [fontIcon]="icon" iconPositionStart></mat-icon>
      {{ name }}
    </button>
  </ng-template>
  <ng-template #checkForOther>
    <ng-container *ngIf="type === 'tertiary-button'; then tertiaryButton; else secondaryButton">
    </ng-container>
    <ng-template #secondaryButton>
      <ng-container *ngIf="name !== 'Cancel' && name!=='Close'; then normalSecondaryButton; else cancelBtn">
      </ng-container>
      <ng-template #normalSecondaryButton>
        <button mat-button [disabled]="disabled" class="secondary-button" [ngClass]="{ 
        'medium': size === 'medium',
        'small': size === 'small'
      }">
          <mat-icon *ngIf="icon !== ''" [fontIcon]="icon" iconPositionStart></mat-icon>
          {{ name }}
        </button>
      </ng-template>
      <ng-template #cancelBtn>
        <button mat-button [disabled]="disabled" class="cancel-btn" [ngClass]="{ 
        'medium': size === 'medium',
        'small': size === 'small'
      }">
          {{name}}
        </button>
      </ng-template>
    </ng-template>
    <ng-template #tertiaryButton>
      <button mat-button [disabled]="disabled" class="tertiary-button" [ngClass]="{ 
        'medium': size === 'medium',
        'small': size === 'small'
      }">
        {{name}}
      </button>
    </ng-template>
  </ng-template>